import React from 'react';
import PropTypes from 'prop-types';

import { View } from 'react-native';

import { Interaction } from '@dbk/ui-charts';

import { Currency } from '../../../../components/common/number';
import SimpleDate from '../../../../components/common/date';
import styles from './interactions.styles';

import theme from '@dbk/ui-theme';
const INTERATION_CIRCLE_DIAMETER = 10;
const INTERACTION_VERTICAL_OFFSET = 95;

function Interactions() {
  return (
    <Interaction xAxis="x">
      <Interaction.XGroup>
        <Interaction.VerticalLine
          top={INTERACTION_VERTICAL_OFFSET}
          gaps={[{ axis: 'y', gap: INTERATION_CIRCLE_DIAMETER }]}
          wrapper={Interaction.HideLink}
        />
        <Interaction.YGroup axis="y">
          <Interaction.Circle d={INTERATION_CIRCLE_DIAMETER}
                              fill={theme.palettePrimaryActive}
          />
        </Interaction.YGroup>
        <Interaction.DataPointView
          top={0}
          view={data => (
            <View style={styles.flag}>
              <SimpleDate
                renderProps={{
                  style: styles.flagDate,
                  //size: 'small',
                }}
                value={data.date}
              />
              <Currency
                renderProps={{
                  style: styles.flagPrice,
                  size: 20,

                }}
                currencyStyle = {{
                  fontSize: 20
                }

                }
                value={data.price.value}
                currency={data.price.unit}
              />
            </View>
          )}
        />
      </Interaction.XGroup>
    </Interaction>
  );
}

Interactions.propTypes = {
  selectedValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.instanceOf(Date),
  ]),
  onChange: PropTypes.func,
};

export default Interactions;
